module.exports = __webpack_public_path__ + "static/media/phila.d46d469a.webp";